import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar } from "@air/primitive-avatar";
import { tailwindMerge } from "@air/tailwind-variants";
import { formatFullName, formatInitials } from "@air/utilities";
import { SelectChipRemoveButton } from "~/components/Select/components/SelectChipRemoveButton";
import { getAvatarImageSrc } from "~/utils/getAvatarImageSrc";
export const UploaderChip = (param)=>{
    let { uploader, uploader: { id, avatar, firstName, lastName }, className, onRemoveUploader } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: tailwindMerge("flex items-center rounded-full bg-grey-3 p-0.5 pr-1.5", className),
        children: [
            /*#__PURE__*/ _jsx(Avatar, {
                appearance: "circle",
                size: 20,
                src: getAvatarImageSrc(avatar, 20),
                text: formatInitials(firstName, lastName),
                colorSeed: id
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "ml-1 mr-0.5 truncate text-12 font-medium text-grey-12",
                children: formatFullName(firstName, lastName)
            }),
            onRemoveUploader && /*#__PURE__*/ _jsx(SelectChipRemoveButton, {
                chip: uploader,
                onClick: onRemoveUploader
            })
        ]
    });
};
